/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CapitalCallBreakdownTableDataRetrieveParams
} from '../../model/capitalCallBreakdownTableDataRetrieveParams'
import type {
  CapitalCallCFReallocationCreateDataRequest
} from '../../model/capitalCallCFReallocationCreateDataRequest'
import type {
  CapitalCallCreditFacilityFeeBasisNotificationData
} from '../../model/capitalCallCreditFacilityFeeBasisNotificationData'
import type {
  CapitalCallUnfundedBreakdownTableDataRetrieveParams
} from '../../model/capitalCallUnfundedBreakdownTableDataRetrieveParams'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  FundFamilyUseAllocationTableData
} from '../../model/fundFamilyUseAllocationTableData'
import type {
  FundFamilyUseAllocationTableDataRequest
} from '../../model/fundFamilyUseAllocationTableDataRequest'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Deletes a capital call event.
 */
export const capitalCallDelete = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getCapitalCallDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof capitalCallDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof capitalCallDelete>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  capitalCallDelete(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CapitalCallDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof capitalCallDelete>>>
    
    export type CapitalCallDeleteMutationError = unknown

    export const useCapitalCallDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCapitalCallDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets capital call breakdown table.
 */
export const capitalCallBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCapitalCallBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getCapitalCallBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>> = ({ signal }) => capitalCallBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>>
export type CapitalCallBreakdownTableDataRetrieveQueryError = unknown

export const useCapitalCallBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalCallBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>> = ({ signal }) => capitalCallBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>>
export type CapitalCallBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useCapitalCallBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalCallBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (CapitalCallBreakdownTableDataRetrieveParams | ((params: Params) => CapitalCallBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalCallBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => capitalCallBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a capital call event and returns the capital call breakdown.
 */
export const capitalCallCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilyUseAllocationTableDataRequest: FundFamilyUseAllocationTableDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyUseAllocationTableDataRequest
    },
      options);
    }
  


export const getCapitalCallCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof capitalCallCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  capitalCallCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CapitalCallCreateMutationResult = NonNullable<Awaited<ReturnType<typeof capitalCallCreate>>>
    export type CapitalCallCreateMutationBody = FundFamilyUseAllocationTableDataRequest
    export type CapitalCallCreateMutationError = unknown

    export const useCapitalCallCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCapitalCallCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Reallocates investments on the line
 */
export const capitalCallCreditFacilityReallocationCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    capitalCallCFReallocationCreateDataRequest: CapitalCallCFReallocationCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/credit-facility-reallocation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capitalCallCFReallocationCreateDataRequest
    },
      options);
    }
  


export const getCapitalCallCreditFacilityReallocationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreditFacilityReallocationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: CapitalCallCFReallocationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreditFacilityReallocationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: CapitalCallCFReallocationCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof capitalCallCreditFacilityReallocationCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: CapitalCallCFReallocationCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  capitalCallCreditFacilityReallocationCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CapitalCallCreditFacilityReallocationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof capitalCallCreditFacilityReallocationCreate>>>
    export type CapitalCallCreditFacilityReallocationCreateMutationBody = CapitalCallCFReallocationCreateDataRequest
    export type CapitalCallCreditFacilityReallocationCreateMutationError = unknown

    export const useCapitalCallCreditFacilityReallocationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof capitalCallCreditFacilityReallocationCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: CapitalCallCFReallocationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCapitalCallCreditFacilityReallocationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets capital call drawdown readonly table data.
 */
export const capitalCallReadOnlyDrawdownTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/drawdown-table`, method: 'GET', signal
    },
      options);
    }
  

export const getCapitalCallReadOnlyDrawdownTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/drawdown-table`] as const;
    }

    
export const getCapitalCallReadOnlyDrawdownTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>> = ({ signal }) => capitalCallReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallReadOnlyDrawdownTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>>
export type CapitalCallReadOnlyDrawdownTableRetrieveQueryError = unknown

export const useCapitalCallReadOnlyDrawdownTableRetrieve = <TData = Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallReadOnlyDrawdownTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalCallReadOnlyDrawdownTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>> = ({ signal }) => capitalCallReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallReadOnlyDrawdownTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>>
export type CapitalCallReadOnlyDrawdownTableRetrieveSuspenseQueryError = unknown

export const useCapitalCallReadOnlyDrawdownTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallReadOnlyDrawdownTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalCallReadOnlyDrawdownTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalCallReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => capitalCallReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets capital call event data for editing.
 */
export const capitalCallRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyUseAllocationTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/edit`, method: 'GET', signal
    },
      options);
    }
  

export const getCapitalCallRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/edit`] as const;
    }

    
export const getCapitalCallRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallRetrieve>>> = ({ signal }) => capitalCallRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallRetrieve>>>
export type CapitalCallRetrieveQueryError = unknown

export const useCapitalCallRetrieve = <TData = Awaited<ReturnType<typeof capitalCallRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalCallRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallRetrieve>>> = ({ signal }) => capitalCallRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallRetrieve>>>
export type CapitalCallRetrieveSuspenseQueryError = unknown

export const useCapitalCallRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalCallRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalCallRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalCallRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => capitalCallRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets capital call fee basis notification table.
 */
export const capitalCallFeeBasisNotificationTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CapitalCallCreditFacilityFeeBasisNotificationData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/fee-basis-notification`, method: 'GET', signal
    },
      options);
    }
  

export const getCapitalCallFeeBasisNotificationTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/fee-basis-notification`] as const;
    }

    
export const getCapitalCallFeeBasisNotificationTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallFeeBasisNotificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>> = ({ signal }) => capitalCallFeeBasisNotificationTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallFeeBasisNotificationTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>>
export type CapitalCallFeeBasisNotificationTableDataRetrieveQueryError = unknown

export const useCapitalCallFeeBasisNotificationTableDataRetrieve = <TData = Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallFeeBasisNotificationTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalCallFeeBasisNotificationTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallFeeBasisNotificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>> = ({ signal }) => capitalCallFeeBasisNotificationTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallFeeBasisNotificationTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>>
export type CapitalCallFeeBasisNotificationTableDataRetrieveSuspenseQueryError = unknown

export const useCapitalCallFeeBasisNotificationTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallFeeBasisNotificationTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallFeeBasisNotificationTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalCallFeeBasisNotificationTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalCallFeeBasisNotificationTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => capitalCallFeeBasisNotificationTableDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets capital call unfunded breakdown table.
 */
export const capitalCallUnfundedBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/unfunded-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCapitalCallUnfundedBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/capital-call/${fundFamilyEventId}/unfunded-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getCapitalCallUnfundedBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>> = ({ signal }) => capitalCallUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallUnfundedBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>>
export type CapitalCallUnfundedBreakdownTableDataRetrieveQueryError = unknown

export const useCapitalCallUnfundedBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallUnfundedBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCapitalCallUnfundedBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCapitalCallUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>> = ({ signal }) => capitalCallUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CapitalCallUnfundedBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>>
export type CapitalCallUnfundedBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useCapitalCallUnfundedBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: CapitalCallUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof capitalCallUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCapitalCallUnfundedBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCapitalCallUnfundedBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (CapitalCallUnfundedBreakdownTableDataRetrieveParams | ((params: Params) => CapitalCallUnfundedBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCapitalCallUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => capitalCallUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      